import { render, staticRenderFns } from "./CommentItemContextMenu.vue?vue&type=template&id=33b1ca3d&"
import script from "./CommentItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./CommentItemContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports